// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Label.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { isNil } from 'lodash/fp';
import localizer from 'share/localization/Izenda.Localizer';

/**
 * Switch(toggle) component.
 * @param {string} id input DOM id
 * @param {string} onLabel "on" state text
 * @param {string} offLabel "off" state text
 * @param {boolean} value
 * @param {function} onChange value changed handler
 */
export default function IzendaSwitch({id, onLabel, offLabel, value, onChange}) {
  const domId = id || String.newGuid();

  return (
    <div className='u_table'>
      <span className='u_tableCell u_alignMiddle'>
        {!isNil(onLabel) ? onLabel : localizer.getText('COMMON_LABEL_OFF')}</span>
      <div className='izenda-Switch u_marginLeftRight'>
        <input
          type='checkbox'
          id={domId}
          className='izenda-Switch-checkbox'
          onChange={onChange}
          checked={value}
        />
        <label className='izenda-Switch-label' htmlFor={domId} />
      </div>
      <span className='u_tableCell u_alignMiddle'>
        {!isNil(offLabel) ? offLabel : localizer.getText('COMMON_LABEL_ON')}
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Switch.js